import { LoadLovs } from './reducer';
import { ILovsReducer } from './types';

export function LoadGlobalLovsAction(lovs: ILovsReducer) {
  return LoadLovs(lovs);
}
